import PropTypes from 'prop-types';
import { Link, useNavigate } from 'react-router';
import { SYSTEM_STATUS } from '@/consts';
import { formatDateShort } from '@/utils/miscUtils';
import SystemActionsDropdown from '@/components/systems/SystemActionsDropdown';

const SystemRow = ({ system, projectId, isSelected = false, onSelectionChange }) => {
  const navigate = useNavigate();

  const viewAnalysis = e => {
    e.preventDefault();
    navigate(`/projects/${projectId}/analysis/systems/${system.id}`);
  };

  const continueBuild = e => {
    e.preventDefault();
    navigate(`/projects/${projectId}/build/systems/${system.id}`);
  };

  return (
    <tr className={`group ${isSelected ? 'bg-gray-50' : 'bg-white hover:bg-gray-50'}`}>
      <td className="py-2 pl-4 pr-0">
        {onSelectionChange && (
          <input
            type="checkbox"
            className="checkbox checkbox-sm"
            checked={isSelected}
            onChange={event => onSelectionChange(system.id, event.target.checked)}
            onClick={event => event.stopPropagation()}
            aria-label={`Select system ${system.name}`}
          />
        )}
      </td>
      <td>
        <Link
          className="flex items-center py-2 px-4 text-sm text-gray-700 hover:text-gray-900"
          to={`/projects/${projectId}/build/systems/${system.id}`}
        >
          {system.name}
        </Link>
      </td>
      <td className="text-left py-2 px-4">
        <div className="flex items-center justify-start min-h-[24px] w-32">
          <span className="group-hover:hidden">
            {system.status === SYSTEM_STATUS.succeeded ? (
              <div className="inline-flex rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                Analysis Complete
              </div>
            ) : (
              <div className="inline-flex items-center rounded-full bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
                In Progress
              </div>
            )}
          </span>
          <span className="group-hover:flex hidden">
            {system.status === SYSTEM_STATUS.succeeded ? (
              <button onClick={viewAnalysis} className="btn btn-xs btn-secondary">
                View Analysis
              </button>
            ) : (
              <button onClick={continueBuild} className="btn btn-xs btn-secondary">
                Continue Build
              </button>
            )}
          </span>
        </div>
      </td>
      <td className="text-left text-sm text-gray-500 py-2 px-4">{formatDateShort(system.created_at)}</td>
      <td className="text-left text-sm text-gray-500 py-2 px-4">{formatDateShort(system.updated_at)}</td>
      <td className="text-right py-2 px-4">
        <div className="flex items-center justify-end min-h-[24px] w-16">
          <span className="group-hover:flex hidden">
            <SystemActionsDropdown system={system} />
          </span>
        </div>
      </td>
    </tr>
  );
};

SystemRow.propTypes = {
  system: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
  }),
  projectId: PropTypes.string,
  isSelected: PropTypes.bool,
  onSelectionChange: PropTypes.func,
};

export default SystemRow;
